import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  loadAssignRoundRequested,
  loadRoundsListRequested,
  storeRoundRequested,
  updateRoundRequested,
} from 'store/round/roundSlice';

export function useLoadRoundsList() {
  const dispatch = useDispatch();
  const onLoadRoundsList = useCallback(async () => {
    await dispatch(loadRoundsListRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadRoundsList();
  }, [onLoadRoundsList]);
  return { onLoadRoundsList };
}

export function useStoreRound() {
  const dispatch = useDispatch();
  const onStoreRound = useCallback(
    async (values: any, actions: any) => {
      actions.setSubmitting(true);
      let data = {
        ...values,
        branchId: values?.branchId?.id,
      };
      await dispatch(storeRoundRequested(data));
      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );
  return { onStoreRound };
}

export function useUpdateRound() {
  const dispatch = useDispatch();
  const onUpdateRound = useCallback(
    async (values: any) => {
      values.branchId = values?.branchId?.id;
      await dispatch(updateRoundRequested(values));
    },
    [dispatch]
  );
  return { onUpdateRound };
}

export function useLoadAsignRound(id: any) {
  const dispatch = useDispatch();
  const onLoadAssignRound = useCallback(async () => {
    await dispatch(loadAssignRoundRequested(id));
  }, [dispatch, id]);
  useEffect(() => {
    onLoadAssignRound();
  }, [onLoadAssignRound]);
  return { onLoadAssignRound };
}
